import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
    ValidationRule,
} from "../services/types/ComponentTypes";

export const screen__166_debit_note: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Tax debit note",
        style: {},
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    direction: FlexDirection.ROW,
                    padding: 0,
                    marginBottom: 10,
                },
                // Commented out as per user's preference shown in credit note
                // childComponents: [
                //     {
                //         componentType: ComponentType.BUTTON,
                //         name: "Back",
                //         Label: "Back",
                //         onPressAction: "navigate_back",
                //         style: {
                //             backgroundColor: "#374151",
                //             textColor: "#FFFFFF",
                //             padding: 8,
                //             borderRadius: 6,
                //         },
                //     },
                // ],
            },
            {
                componentType: LayoutTypes.FORM,
                Name: "debit_note_add",
                TableName: "vouchers",
                DisplayName: "vouchers",
                columnNumber: "m1 t1 w1",
                style: {
                    padding: 16,
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                },
                Fields: [
                    {
                        componentType: LayoutTypes.FIELD_GROUP,
                        Label: "Debit note details",
                        BindValue: "debit_note_details",
                        style: {
                            direction: FlexDirection.COLUMN,
                        },
                        childComponents: [
                            {
                                IncludeLabel: true,
                                Label: "Voucher No.",
                                PlaceHolder: "Will be auto generated...",
                                IsMandatory: false,
                                BindValue: "txt_voucher_no",
                                Json_Attribute: "voucher_no",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                AutoPopulate: true,
                                IsReadOnly: true,
                                AutoPopulate_format: "DBN_[******]",
                                IsVerticalView: true,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Vendor",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "drp_supplier",
                                Json_Attribute: "supplier_id",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                showInSummary: true,
                                LookupName: "supplier_with_due_from_transaction",
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Vendor is required",
                                    },
                                ],
                            },
                            {
                                IncludeLabel: true,
                                Label: "Jobcard No.",
                                BindValue: "job_card_id",
                                Json_Attribute: "job_card_id",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                LookupName: "voucher_jobcard",
                                IsMandatory: false,
                                showInSummary: true,
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Voucher date",
                                IsMandatory: true,
                                BindValue: "txt_voucher_date",
                                Json_Attribute: "voucher_date",
                                componentType: ComponentType.DATE_FIELD,
                                showInSummary: true,
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Voucher date is required",
                                    },
                                ],
                            },
                            {
                                IncludeLabel: true,
                                Label: "Remarks",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_remarks",
                                Json_Attribute: "narration",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: true,
                                IsVerticalView: true,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Ref No.",
                                PlaceHolder: "Ref No.",
                                IsMandatory: false,
                                BindValue: "txt_Ref_no",
                                Json_Attribute: "ref_no",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: true,
                                IsVerticalView: true,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Voucher type",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_voucher_type_",
                                Json_Attribute: "voucher_type",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: true,
                                Default_Value: "DebitNote",
                                IsReadOnly: true,
                                IsVerticalView: true,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Reference date",
                                IsMandatory: true,
                                BindValue: "txt_reference_date",
                                Json_Attribute: "ref_date",
                                componentType: ComponentType.DATE_FIELD,
                                showInSummary: true,
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Reference date is required",
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        componentType: ComponentType.SUB_MODULE,
                        name: "purchase_details",
                        label: "Purchase details",
                        tableName: "purchase_payment_split",
                        BindValue: "purchase_payment_split",
                        LookupName: "vendor_purchase_details",
                        parentField: "drp_supplier",
                        EnableAddActionForSubModule: false,
                        NotAllowEmpty:true,
                        childControls: [
                            {
                                IncludeLabel: true,
                                Label: "Invoice No.",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_purchase_no",
                                Json_Attribute: "purchase_no",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsVerticalView: true,
                                IsReadOnly: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Total amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_total_amount",
                                Json_Attribute: "total_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: true,
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Amount paid",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_paid_amount",
                                Json_Attribute: "amount_paid",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: true,
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Discount amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_discount_amount",
                                Json_Attribute: "discounted_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: true,
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Due amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_due_amount",
                                Json_Attribute: "due_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[txt_total_amount] - [txt_paid_amount]-[txt_discount_amount]",
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_amount",
                                Json_Attribute: "amount",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: false,
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                            },
                        ],
                        FooterControls: [
                            {
                                IncludeLabel: false,
                                Label: "Net Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_net_amount",
                                Json_Attribute: "net_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_amount]",
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                            },
                        ],
                    },
                    {
                        componentType: ComponentType.SUB_MODULE,
                        name: "voucher_details",
                        label: "Voucher details",
                        tableName: "voucher_details",
                        BindValue: "voucher_details",
                        LookupName: "debit_note_ledgers_with_parent_id",
                        parentField: "drp_supplier",
                        EnableAddActionForSubModule: false,
                        NotAllowEmpty:true,
                        childControls: [
                            {
                                IncludeLabel: true,
                                Label: "Ledger",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "drp_ledger",
                                Json_Attribute: "ledger_id",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                IsVerticalView: true,
                                showInSummary: false,
                                IsReadOnly: false,
                                LookupName: "credit_note_ledgers", // The JSON uses credit_note_ledgers even for debit note
                                EnableEditForControl: false,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Ledger is required",
                                    },
                                ],
                            },
                            {
                                IncludeLabel: true,
                                Label: "Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_credit",
                                Json_Attribute: "credit",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: false,
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Description",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "txt_remarks",
                                Json_Attribute: "remarks",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: true,
                                IsVerticalView: false,
                                inputType: InputType.TEXT,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Description is required",
                                    },
                                ],
                            },
                        ],
                        FooterControls: [
                            {
                                IncludeLabel: false,
                                Label: "Total credit",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_total_credit",
                                Json_Attribute: "total_credit",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_credit]",
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                                validation: [
                                    {
                                        rule: ValidationRule.PATTERN,
                                        message: "The allocated amount should be equal to the debit note amount",
                                    }
                                ]
                            },
                        ],
                    },
                    {
                        componentType: LayoutTypes.GROUP,
                        style: {
                            direction: FlexDirection.ROW,
                            justifyContent: "flex-end",
                            gap: 12,
                            marginTop: 20,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.BUTTON,
                                name: "Submit",
                                Label: "Submit",
                                onPressAction: "save",
                                style: {
                                    backgroundColor: "#22c55e",
                                    textColor: "#FFFFFF",
                                    padding: "10px 24px",
                                    borderRadius: 8,
                                    fontWeight: "600",
                                },
                            },
                            // {
                            //     componentType: ComponentType.BUTTON,
                            //     name: "Cancel",
                            //     Label: "Cancel",
                            //     onPressAction: "navigate_back",
                            //     style: {
                            //         backgroundColor: "#ef4444",
                            //         textColor: "#FFFFFF",
                            //         padding: "10px 24px",
                            //         borderRadius: 8,
                            //         fontWeight: "600",
                            // },
                            // },
                        ],
                    },
                ],
            },
        ],
    },
];

export const screen_166_debit_note = screen__166_debit_note;
